import { axios } from '@/utils/request'
// 共享图库分类
export function getMaterialCategory() {
  return axios({
    url: '/frontend/materialCategory',
    method: 'GET'
  })
}
// 共享图库列表
export function getOpenMaterial(params) {
  return axios({
    url: '/distribution/openMaterial',
    method: 'GET',
    params
  })
}

// 获取用户分类
export function getUserMaterialCategory(params) {
  return axios({
    url: '/distribution/userMaterialCategory',
    method: 'GET',
    params
  })
}
// 设置收藏
export function setMaterialColletion(data) {
  return axios({
    url: '/distribution/materialColletion',
    method: 'POST',
    data
  })
}
// 取消收藏
export function delMaterialColletion(data) {
  return axios({
    url: '/distribution/materialColletion/deletes',
    method: 'POST',
    data
  })
}
